import { Image } from '@storyofams/storyblok-toolkit';
import { format } from 'date-fns';

import { getLinkProps } from '~/lib';
import { Heading } from '../Heading';
import { ArrowRight, PlayIcon } from '../Icons';
import { Link } from '../Link';

export const EventCard = ({
  event,
  cta,
  video,
}: {
  event: any;
  cta?: string;
  video?: boolean;
}) => {
  return (
    <Link href={getLinkProps(event?.full_slug)}>
      <a className="w-full flex flex-col justify-between md:space-y-10 group relative">
        <div>
          <div className="w-full aspect-[520/264] overflow-hidden rounded-2xl relative mb-6">
            <div className="bg-white px-2.5 py-1 text-gray-700 rounded-2xl absolute top-5 left-5 z-10">
              {!!event?.content?.date
                ? format(
                    new Date(event?.content?.date?.replace(/-/g, '/')),
                    'dd-MM-yyyy',
                  )
                : !!event?.content?.label && <span>{event.content.label}</span>}
            </div>
            {!!event?.content?.image?.filename && (
              <Image
                alt={event?.content?.image?.alt || event?.content?.title || ''}
                src={event?.content?.image?.filename}
                fit="contain"
                fluid={520}
                className="rounded-2xl overflow-hidden"
              />
            )}
            {video && (
              <div className="bg-yellow-500 rounded-full w-14 aspect-1 absolute top-1/2 -translate-y-1/2 z-20 left-1/2 -translate-x-1/2 flex items-center justify-center">
                <PlayIcon className="w-4 relative left-0.5" />
              </div>
            )}
          </div>

          {!!event?.content?.kicker && (
            <div className="uppercase text-gray-600 text-sm mb-2 md:mb-4">
              {event?.content?.kicker}
            </div>
          )}

          {!!event?.content?.title && (
            <Heading as="h5" variant="h5">
              {event?.content?.title}
            </Heading>
          )}
        </div>

        <div className="flex flex-col md:flex-row md:justify-between">
          <div className="mt-2 md:mt-0">
            {event?.content?.hosts?.length > 0 && (
              <span>
                by{' '}
                <span className="font-bold">
                  {event?.content?.hosts?.[0]?.content?.name}
                </span>
              </span>
            )}
          </div>

          {!video && (
            <div className="flex items-center mt-5 md:mt-0">
              <div>{cta || 'Register now'}</div>
              <ArrowRight className="w-3 h-5 ml-2 group-hover:translate-x-2 transition-transform" />
            </div>
          )}
        </div>
      </a>
    </Link>
  );
};
